<template>
  <div class="text-left">
    Mon tableau de bord
  </div>
</template>

<script>
export default {
  name: "RestaurantDashboardPage",
}
</script>

<style scoped>
.text-left {
  padding: 16px;
}
</style>
